import React from "react";
import { formatAsDate } from "@utilities/formatDate";

type ProducerProductDisplayProps = {
  product: {
    id: number;
    name: string;
    packageType?: {
      displayName: string;
    };
    packageDate?: string;
    productImage?: {
      rawUrl: string;
      thumbnailUrl: string;
    } | null;
  };
};

export function ProducerProductDisplay({
  product,
}: ProducerProductDisplayProps) {
  return (
    <div className="inline-flex">
      <div className="h-[60px] w-[60px] mr-4">
        {product.productImage?.thumbnailUrl ? (
          <img
            src={product.productImage.thumbnailUrl}
            className="h-full w-full object-contain"
          />
        ) : (
          <div className="w-full h-full bg-gray-200 flex items-center justify-center text-xs muted"></div>
        )}
      </div>
      <div>
        <span>
          {product.name} &nbsp;(ID: {product.id})
        </span>
        <div className="text-sm">
          {product.packageType?.displayName} <br />
          {product.packageType && product.packageDate
            ? "packaged on " + formatAsDate(product.packageDate)
            : ""}
        </div>
      </div>
    </div>
  );
}
